export const slider = () => {

	let els = document.querySelectorAll('[data-animation="slider"]')

	if (!els) return

	els.forEach(el => {

		el.style.opacity = 1

		let imageContainer = el.querySelector('[data-el="top-image"]');

		if (!imageContainer) return

		imageContainer.style.opacity = 1

		// let image = imageContainer.querySelector('img');
		let range = el.querySelector('input[type="range"]');

		range.oninput = function () {
			imageContainer.style.width = this.value + "%";
		}

	})

}

export default () => { }